import React from 'react';
import {DirectoryAudioItem} from 'features/Provider/Experiences/WellniteAudios/Library/DirectoryAudioItemV2';
import {useWellniteAudios} from 'hooks';
import {useTranslation} from 'react-i18next';
import {isMobile} from 'utils';

interface ArticleListProps {
  userId: string;
  role: string;
}

export function ProviderAudioList({
  userId,
  role,
}: ArticleListProps): React.ReactElement {
  const {audios, handlePlay, currentlyPlayingId, isLoadingAudios} =
    useWellniteAudios(userId, 20, role);

  const {t} = useTranslation();
  const max = isMobile ? 2 : 3;

  return (
    <section className="text-left @container mb-12">
      <div className="flex flex-row justify-between items-center">
        <h2 className="text-[22px] font-montserrat pt-4 pb-4 font-semibold">
          {t('wellniteContent.directBookingAudiosTitle', 'My Audios')}
        </h2>
        {/* {audios && audios?.length > max ? (
          <a className="font-semibold font-inter cursor-pointer text-sm">
            {t('wellniteContent.viewAll', 'View All')}
          </a>
        ) : null} */}
      </div>

      {!isLoadingAudios && userId ? (
        <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
          {audios?.length ? (
            audios
              ?.slice(0, max)
              ?.map(audio => (
                <DirectoryAudioItem
                  key={audio._id}
                  {...audio}
                  isPlaying={currentlyPlayingId === audio._id}
                  onPlay={handlePlay}
                />
              ))
          ) : (
            <h3 className="col-span-full flex justify-center items-center min-h-[100px]">
              {t('wellniteContent.noAvailableAudios', 'No audio available')}
            </h3>
          )}
        </div>
      ) : (
        <AudioSkeletonLoader />
      )}
    </section>
  );
}

const AudioSkeletonLoader = () => {
  return (
    <div className=" grid grid-cols-3 gap-4">
      {[...Array(3)].map((_, index) => (
        <div key={index} className="flex flex-col items-center space-y-4">
          <div className="w-full h-[110px] bg-gray-300 rounded-xl animate-pulse"></div>
          <div className="flex-1 space-y-2">
            <div className="h-4 bg-gray-300 rounded animate-pulse w-3/4"></div>
            <div className="h-4 bg-gray-300 rounded animate-pulse w-1/2"></div>
          </div>
        </div>
      ))}
    </div>
  );
};
